var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointOfInterestStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "#ffffff",
    stroke: "#8e24aa",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 14) scale(1.5)",
    fill: "none",
    stroke: "#8e24aa",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 9q3-4 6 0t6 0 6 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16q3-4 6 0t6 0 6 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointOfInterestStream);
export default __webpack_public_path__ + "static/media/PointOfInterestStream.0523fb5b2df67c9a6113c8ef792741b5.svg";
export { ForwardRef as ReactComponent };